import serviceStore from 'relapp-technical-management/src/store/services';
export default serviceStore;
